/*! js-cookie v3.0.1 | MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self,function(){var n=e.Cookies,o=e.Cookies=t();o.noConflict=function(){return e.Cookies=n,o}}())}(this,(function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)e[o]=n[o]}return e}return function t(n,o){function r(t,r,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n.write(r,t)+c}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var t=document.cookie?document.cookie.split("; "):[],o={},r=0;r<t.length;r++){var i=t[r].split("="),c=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(o[u]=n.read(c,u),e===u)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){r(t,"",e({},n,{expires:-1}))},withAttributes:function(n){return t(this.converter,e({},this.attributes,n))},withConverter:function(n){return t(e({},this.converter,n),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(n)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"})}));

/*! js-url - v2.5.0 - 2017-04-22 */
  !function(){var a=function(){function a(){}function b(a){return decodeURIComponent(a.replace(/\+/g," "))}function c(a,b){var c=a.charAt(0),d=b.split(c);return c===a?d:(a=parseInt(a.substring(1),10),d[a<0?d.length+a:a-1])}function d(a,c){for(var d=a.charAt(0),e=c.split("&"),f=[],g={},h=[],i=a.substring(1),j=0,k=e.length;j<k;j++)if(f=e[j].match(/(.*?)=(.*)/),f||(f=[e[j],e[j],""]),""!==f[1].replace(/\s/g,"")){if(f[2]=b(f[2]||""),i===f[1])return f[2];h=f[1].match(/(.*)\[([0-9]+)\]/),h?(g[h[1]]=g[h[1]]||[],g[h[1]][h[2]]=f[2]):g[f[1]]=f[2]}return d===a?g:g[i]}return function(b,e){var f,g={};if("tld?"===b)return a();if(e=e||window.location.toString(),!b)return e;if(b=b.toString(),f=e.match(/^mailto:([^\/].+)/))g.protocol="mailto",g.email=f[1];else{if((f=e.match(/(.*?)\/#\!(.*)/))&&(e=f[1]+f[2]),(f=e.match(/(.*?)#(.*)/))&&(g.hash=f[2],e=f[1]),g.hash&&b.match(/^#/))return d(b,g.hash);if((f=e.match(/(.*?)\?(.*)/))&&(g.query=f[2],e=f[1]),g.query&&b.match(/^\?/))return d(b,g.query);if((f=e.match(/(.*?)\:?\/\/(.*)/))&&(g.protocol=f[1].toLowerCase(),e=f[2]),(f=e.match(/(.*?)(\/.*)/))&&(g.path=f[2],e=f[1]),g.path=(g.path||"").replace(/^([^\/])/,"/$1"),b.match(/^[\-0-9]+$/)&&(b=b.replace(/^([^\/])/,"/$1")),b.match(/^\//))return c(b,g.path.substring(1));if(f=c("/-1",g.path.substring(1)),f&&(f=f.match(/(.*?)\.(.*)/))&&(g.file=f[0],g.filename=f[1],g.fileext=f[2]),(f=e.match(/(.*)\:([0-9]+)$/))&&(g.port=f[2],e=f[1]),(f=e.match(/(.*?)@(.*)/))&&(g.auth=f[1],e=f[2]),g.auth&&(f=g.auth.match(/(.*)\:(.*)/),g.user=f?f[1]:g.auth,g.pass=f?f[2]:void 0),g.hostname=e.toLowerCase(),"."===b.charAt(0))return c(b,g.hostname);a()&&(f=g.hostname.match(a()),f&&(g.tld=f[3],g.domain=f[2]?f[2]+"."+f[3]:void 0,g.sub=f[1]||void 0)),g.port=g.port||("https"===g.protocol?"443":"80"),g.protocol=g.protocol||("443"===g.port?"https":"http")}return b in g?g[b]:"{}"===b?g:void 0}}();"function"==typeof window.define&&window.define.amd?window.define("js-url",[],function(){return a}):("undefined"!=typeof window.jQuery&&window.jQuery.extend({url:function(a,b){return window.url(a,b)}}),window.url=a)}();

function inch_to_cm(val_inch){
  return (val_inch*2.54).toFixed(0);
}
function cm_to_inch(val_cm){
  return (val_cm*0.39370079).toFixed(0);
}
document.addEventListener('DOMContentLoaded', () => {
var el = document.querySelector('body.template-collection main#main > :first-child > [data-section-type="collection-intro"]'),
  body_ele = document.querySelector('body');
if(el){
  if(el.classList.contains('show_as_slideshow-false')){
    body_ele.classList.add('js-collection-text-only');
  }
  else{
    body_ele.classList.remove('js-collection-text-only');
  }
}
});

Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

var quickFilter = {

  animatePLPGrid:function(selector){
    window.Shopify.designMode !== true && anime({
      targets: selector,
      translateY: [60, 0],
      opacity: 1,
      easing: 'cubicBezier(.5, .05, .1, .3)',
      duration: 400,
      delay: anime.stagger(200)
    });
  },
  init: function(){
    var selectedOptions = [],
        query = '',
        currentTags = '',
        siteUrl = 'https://' + $.url('hostname'),
        url1 = $.url('1') ? '/' + $.url('1') + '/' : '',
        url2 = $.url('2') ? $.url('2') + '/' : '',
        url3 = $.url('3'),
        path = url1 + url2;

    //Handle dropdowns if they exist
    if ($('input[name="sort_by"]').length){
      query = $('input[name="sort_by"]:checked').val();
    } else {
      query = url('?sort_by');
    }


    //Add all checkbox values to array
    $('[data-action="toggle-tag"] input:checked').each(function (){
      selectedOptions.push($(this).val());
    });
    selectedOptions = $.makeArray(selectedOptions);

    //Loop through tags to create string to update page url
    $.each(selectedOptions, function(i, value){

      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }

    });

    Shopify.queryParams.sort_by = query;
    query = '?' + $.param(Shopify.queryParams);

    quickFilter.processUrl(path, currentTags, query);
  },
  updateView: function(filterURL) {

    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function() {
        $("[data-js-loading]").addClass('is-active');
      },
      success: function(data) {
        $("[data-js-loading]").removeClass('is-active');
        
        var filteredPageLinks = $(data).find('.paginate').html();
        $('.paginate').empty();
        $('.paginate').html(filteredPageLinks);

        var filteredData = $(data).find('[data-js-partial]');
        $('#root.collection__main').remove();
        filteredData.insertBefore( $('.js-collection-footer') );
        quickFilter.animatePLPGrid('.animate.animate-up')
        window.history && window.history.pushState && window.history.pushState("", "", filterURL);
      },
      error: function(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);

      },
      dataType: "html"
    });
  },
  processUrl: function(path, tags, query){

    var query = query.replace(/\page=(\w+)&/, ''),
        urlString = '';

    urlString = path + tags + query;

    console.log('filter triggered. ',urlString)
    quickFilter.updateView(urlString);

  }
}



$(document).ready(function(){


  //Check the checkbox values

  var filter_selectors = '.collection-sidebar__group [data-action="toggle-tag"] input';
  $(filter_selectors).on('click', function() {
    // in the handler, 'this' refers to the box clicked on
    var $box = $(this);
    if ($box.is(":checked")) {
      // the name of the box is retrieved using the .attr() method
      // as it is assumed and expected to be immutable
      var group = "input:checkbox[name='" + $box.attr("name") + "']";
      // the checked state of the group/box on the other hand will change
      // and the current value is retrieved using .prop() method
      $(group).prop("checked", false);
      $box.prop("checked", true);
    } else {
      $box.prop("checked", false);
    }
  });
  $('body').on('change',filter_selectors, function(){
    quickFilter.init();
  })

  $('body')
  .on('change', 'input[name="sort_by"]', function() {
    quickFilter.init();
  });

  const swiper = new Swiper('.featured-products__blocks', {
    // Optional parameters
    loop: true,
    slidesPerView: 1,
    draggable: true,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  $('body').on('click','[data-role="tab"]',function(e){
    var target = $(this).attr('data-target'),
        tab_content = $(target);
    //   console.log(tab_content)

    $('[data-role="tab"]').removeClass('is-active')
    $(this).addClass('is-active');

    $('[role="tabpanel"]').removeClass('is-active')
    tab_content.addClass('is-active');
  })
  
  /*Size chart popup inch to cm code */
  $('body').on('click','.content-size li',function(){
    var current = $(this);
    $('.content-size li').removeClass('active')
    current.addClass('active');
    var size = $(this).attr('data-unit');
    if(size=="inch"){
      $('table.sizing-modal-table tr td').each(function(index,el){
        if(index>0){
          var strHtml = "";
          var current_ele = $(this);
          var sizes = $(this).attr('data-val');
          current_ele.text(sizes);
        }
      })
    }
    else{
      $('table.sizing-modal-table tr td').each(function(index,el){
        //     console.log(index)
        if(index>0){
          var strHtml = "";
          var current_ele = $(this);
          if($(this).attr('data-val')){
            var sizes = $(this).attr('data-val').split("-");
//             console.log(current_ele,sizes)
            if(sizes.length==1){
              var inches = inch_to_cm(parseInt(sizes[0]));
              current_ele.text(inches)
            }
            else{
              var cms1 = inch_to_cm(parseInt(sizes[0])),
                  cms2 = inch_to_cm(parseInt(sizes[1]));
              current_ele.text(cms1 + "-"+cms2)
            }
          }
        }
      })
    }
  })
  /*Size chart popup inch to cm code */
  
  
//   fetch('/browsing_context_suggestions.json?currency[enabled]=true')
//   .then(response => response.json())
//   .then(data => console.log(data));
  
  var window_width = $(window).width();
  function plp_filter(){
    var filter_cookie = Cookies.get('filter_state');
    if($(window).width()>640){
//       console.log(filter_cookie)
      if(filter_cookie != undefined){
        $('[data-filter-trigger]').addClass('animate-appear');
        if(filter_cookie == 'opened'){
          $('[data-filter-trigger] span').text('Hide Filters');
          $('[data-js-sidebar]').show()
        }
        else{
          $('[data-filter-trigger] span').text('Show Filters');
          $('[data-js-sidebar]').hide()
        }
      }
      else{
        $('[data-filter-trigger]').addClass('animate-appear');
        $('[data-filter-trigger] span').text('Hide Filters');
        $('[data-js-sidebar]').show()
      }
    }
    else{
//       console.log('ere',filter_cookie)
      if(filter_cookie == 'opened'){
        $('[data-filter-trigger] span').text('Hide Filters');
        $('[data-js-sidebar]').hide()
      }
    }
  }
  function collection_grid(){
    $('body').on('click','.js-colletion-view-trigger',function(){
      var view1 = parseInt($(this).attr('data-view')),
          view2 = parseInt($(this).attr('data-mobile-view'));
//       console.log(view1,view2)
      $('.js-colletion-view-trigger').removeClass('active');
      $(this).toggleClass('active');
      if($(window).width()>798){
        $('.collection__grid').attr('data-view',view1);
      }
      else{
        $('.collection__grid').attr('data-view-mobile',view2)
      }
    })
  }

  function addLvltoMobileMenus(){
    $('ul.drawer-menu__primary-links li[data-list-item]:not(.drawer-menu__item--heading):not(.mobile-nav__link--level-2):not(.mobile-nav__link--level-3)').addClass('mobile-nav__link--level-1');
    $('ul.drawer-menu__primary-links li[data-list-item] ul li:not(.drawer-menu__item--heading)').addClass('mobile-nav__link--level-2')
    $('ul.drawer-menu__primary-links li[data-list-item] ul ul li:not(.drawer-menu__item--heading)').removeClass('mobile-nav__link--level-2').addClass('mobile-nav__link--level-3')
  }
  
  plp_filter();
  collection_grid();
  addLvltoMobileMenus();

  $('body').on('click','[data-filter-trigger]',function(){
    var $this = $(this);
    Cookies.remove('filter_state');
    if($('[data-js-sidebar]').is(':visible')){
      $this.find('span').text('Show Filters');
      Cookies.set('filter_state', 'closed',365);
    }
    else{
      $this.find('span').text('Hide Filters');
      Cookies.set('filter_state', 'opened',365);
    }
//     console.log(Cookies.get('filter_state'))
    $('[data-js-sidebar]').toggle(300)
  })
  
  $(window).on('resize',function(){
    plp_filter();
    collection_grid();
  });
  
  
  $('.mobile-nav__trigger').on('click',function(e){
    var ul = $(this).parent().find('.mobile-dropdown>ul:eq(0)');
//     console.log(ul)
    $(this).toggleClass('active')
    if(ul.hasClass('mobile-nav__sublist')){
      ul.toggleClass('active')
    }
    else if(ul.hasClass('mobile-nav__sub-sublist')){
      ul.toggleClass('active')
    }
    
  })
  

  let isPlaying = false;
  let curr_track = $("#site-music")[0];
  $('body').on('click','.js-music-toggle',function(e){
    e.preventDefault();
    curr_track.muted=false;
    $(this).toggleClass('music-on');
    curr_track.play();
    if(!$(this).hasClass('music-on')){
      curr_track.pause();
      isPlaying = false;
    }
  })
 
//   if($('#site-music').hasClass('js-autoplay')){
//     let curr_track2 = $("#site-music")[0];
//     curr_track2.muted=false;
//     console.log(curr_track2)
//     curr_track2.play();
// //     $('.js-music-toggle:eq(0)').trigger('click')
// //     $('.js-music-toggle:eq(0)').trigger('click')
//   }
  
//   var image = document.getElementsByClassName('simple_parallax');
//   new simpleParallax(image, {
//     overflow: true,
//     scale: 1.5,
//   });
          // Listen for the event.
  document.addEventListener('quickCart:opened', function (e) {
//     console.log(e.detail)
//     var inst = $('[data-remodal-id=modal]').remodal();
  }, false);


  $(document).on('click','[data-remodal-action="close"]',function(){
    var modal_overlay = $(this).parents('.popup-main-inner').find('.quick-cart__overlay');
    console.log(modal_overlay)
    modal_overlay.trigger('click')
  })
  
})

